<template lang="pug">
shListData(title="Article Defaults History" resolver="articleDefaultsHistory" keyData="_id" component="shArticleDefault" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'ArticleDefaultsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/articleDefault/ArticleDefaultsHistory.vue